<template>
    <div class="light-color-bg position-relative">
        <QuestionTitle number="03" :question="question" :comment="comment" :modalActivator="true" @activateModal="modalActive=true" :modalActive="modalActive"></QuestionTitle>
        <div class="container-70">
            <SuperficieEvent v-model="result"></SuperficieEvent>
            <div v-if="result!=null" @click="saveAndContinue('superficieOrganisation', JSON.stringify(result), '/resultats')"  class="btn-primary d-block w-100 mt-50px text-center">Suivant</div>
            <AvancementLine percent="100%" class="mt-50px"></AvancementLine>
        </div>
        <ModalInfo @closeModal="modalActive=false" v-if="modalActive">
            <h3 class="modal-title">GES émis par votre bâtiment</h3>
            <p class="modal-text">Les GES émis par un bâtiment relèvent de la consommation énergétique nécessaire pour le chauffer. Plusieurs facteurs déterminent la quantité de GES émis, tels que la source d'énergie utilisée, les besoins et habitudes de consommation d'énergie, la performance énergétique du bâtiment, ainsi que sa superficie.</p>
        </ModalInfo>
    </div>
</template>
<script>
import QuestionTitle from '@/components/QuestionTitle.vue'
import AvancementLine from '@/components/AvancementLine.vue'
import SuperficieEvent from '@/components/SuperficieEvent.vue'
import ModalInfo from '@/components/ModalInfo.vue'
/*Mixins*/
import utils from '@/mixins/utils'
export default {
    data() {
        return {
            result:null,
            modalActive:false,
            question:'Quelle est la superficie (m2) des locaux ou des bâtiments de votre organisation?',
        }
    },
    components: {
        QuestionTitle,
        SuperficieEvent,
        ModalInfo,
        AvancementLine
    },
    mixins:[utils],
    mounted(){
        if(sessionStorage.getItem('superficieOrganisation')){
            this.result=JSON.parse(sessionStorage.getItem('superficieOrganisation'))
        }
    }
}
</script>